import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=2f11c17a"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports